import type {RecoInfo} from '@/modules/common/hooks/useRecommendations/models';
import type {
  BD4TravelEcommerceItem,
  BD4TravelElement,
  EventAction,
  EventActionCreator,
  EventHandler,
  Recommendation,
} from '@/redux/middleware/googleTagManager/types';

import {EVENT_BD4_RECOMMENDED_LOADED} from '@/redux/middleware/googleTagManager/actionTypes';
import {mapHotelRecommendedDataToEcommerceElement} from '@/redux/middleware/googleTagManager/utils/mapHotelRecommendedDataToEcommerceElement';
import {mapHotelRecommendedDataToEcommerceItem} from '@/redux/middleware/googleTagManager/utils/mapHotelRecommendedDataToEcommerceItem';
import {waitForGtmDomEvent} from '@/redux/middleware/googleTagManager/utils/waitForGtmDomEvent';

type Payload = {
  recommendations: Array<Recommendation>;
};

type Action = EventAction<Payload>;

type NullEvent = {
  ecommerce: null;
};

type Event = {
  event: string;
  event_action: string;
  non_interaction: boolean;
  list_offset: number;
  page_size: number;
  total: number;
  ecommerce: {
    items: Array<BD4TravelEcommerceItem>;
  };
  elements: Array<BD4TravelElement>;
  recoInfo: RecoInfo;
};

export const action: EventActionCreator<Action, Payload> = (payload) => ({
  type: EVENT_BD4_RECOMMENDED_LOADED,
  payload,
});

export const handler: EventHandler<
  Action,
  Promise<[NullEvent, Event]>
> = waitForGtmDomEvent<[NullEvent, Event], Payload>((eventAction) => {
  const {recommendations} = eventAction.payload;
  const pageSize = Math.min(recommendations.length, 15);

  return [
    {ecommerce: null},
    {
      event: 'view_promotion',
      event_action: 'BD4_recommender_loaded',
      non_interaction: true,
      // the zero-based index of the first visible item - will be fixed to 0
      list_offset: 0,
      page_size: pageSize,
      total: recommendations?.length,
      ecommerce: {
        promotion_name: 'BD4 recommender',
        items: recommendations.map((recommendation) =>
          mapHotelRecommendedDataToEcommerceItem(recommendation)
        ),
      },
      elements: recommendations.map((recommendation) =>
        mapHotelRecommendedDataToEcommerceElement(recommendation)
      ),
      recoInfo: recommendations[0]?.recoInfo,
    },
  ];
});
